enum ListSortFieldEnum {
    CreatedTime = 'CREATED_TIME',
    LoanAmount = 'LOAN_AMOUNT',
}

export default ListSortFieldEnum;